var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BehaviorSubject } from 'rxjs';
import * as crypto from 'crypto-js';
import { DwAuthService, DwUserService, DwSystemConfigService, DwRoutingMessageService } from '@webdpt/framework';
// import { CustUserService } from './cust-user.service';
import { LocalStorage } from '@webdpt/framework';
var FxAuthService = /** @class */ (function (_super) {
    __extends(FxAuthService, _super);
    //loginSubject: BehaviorSubject<boolean>; // 廣播登入狀態
    //loginSuccess = (this.custUserService.getUser('isLoggedin') && JSON.parse(this.custUserService.getUser('isLoggedin'))) ? true : false;
    function FxAuthService(custRouter, custUserService, custStorage, http, dwMessage, authToken, custDefaultApp, defaultLogin, usingFrSSO, configService, dwAppAuthToken) {
        var _this = _super.call(this, custRouter, custUserService, custStorage, http, authToken, custDefaultApp, defaultLogin, usingFrSSO, configService) || this;
        _this.custRouter = custRouter;
        _this.custUserService = custUserService;
        _this.custStorage = custStorage;
        _this.http = http;
        _this.dwMessage = dwMessage;
        _this.authToken = authToken;
        _this.custDefaultApp = custDefaultApp;
        _this.defaultLogin = defaultLogin;
        _this.usingFrSSO = usingFrSSO;
        _this.configService = configService;
        _this.dwAppAuthToken = dwAppAuthToken;
        _this.configService.getConfig().subscribe(function (config) {
            //this.msgURL = config.msgUrl + 'api/emc/v1/';
            //this.iamURL = config.iamUrl + 'api/iam/v2/';
        });
        _this.loginSubject = new BehaviorSubject(_this.loginSuccess);
        return _this;
    }
    FxAuthService.prototype.login = function (userConfig) {
        var _this = this;
        var info = {
            success: false,
            description: '',
            isFirstLogin: false //是否是首次登陆
        };
        return new Observable(function (observer) {
            //this.logining().subscribe(
            //  result => {
            //    if (!result) {
            //      info.success = false;
            //      info.description = '登入失敗';
            //      observer.next(info);
            //      observer.complete();
            //      return;
            //    }
            //密码md5编码一下
            var md5_password = crypto.MD5(userConfig.password);
            console.log("md5_password:" + md5_password);
            var userParam = {
                userId: userConfig.userId,
                password: md5_password + '',
                ent: userConfig.ent,
                is_eshop_login: 'Y'
            };
            console.log('userConfig.captchaKey:', userConfig.captchaKey);
            //有验证码登录
            if (userConfig.captchaKey.isCaptcha) {
                _this.http.post('A/ILoginService/login', {
                    param: userParam, captchaDataMap: userConfig.captchaKey
                }).subscribe(function (response) {
                    console.log('login response:', response);
                    var token = { id: 'token', value: response.token };
                    _this.userService.setUser(token);
                    var userId = { id: 'userId', value: userConfig.userId };
                    _this.userService.setUser(userId);
                    _this.setLogined(userId);
                    //console.log('token:',this.userService.getUser('token'));
                    var data = JSON.parse(response.data);
                    console.log("response.data.isFirstLogin:", data.isFirstLogin);
                    if (data.isFirstLogin === 'Y') {
                        info.isFirstLogin = true;
                    }
                    info.success = true;
                    observer.next(info);
                    observer.complete();
                    return;
                }, function (error) {
                    console.log('登录error:', error);
                    _this.dwMessage.error(error.error.errorMessage);
                    info.success = false;
                    info.description = error.error.errorMessage;
                    observer.error(info);
                    observer.complete();
                });
            }
            else { //无验证码登录
                _this.http.post('A/ILoginService/login', {
                    param: userParam
                }).subscribe(function (response) {
                    console.log('login response:', response);
                    var token = { id: 'token', value: response.token };
                    _this.userService.setUser(token);
                    var userId = { id: 'userId', value: userConfig.userId };
                    _this.userService.setUser(userId);
                    _this.setLogined(userId);
                    //console.log('token:',this.userService.getUser('token'));
                    var data = JSON.parse(response.data);
                    console.log("response.data.isFirstLogin:", data.isFirstLogin);
                    if (data.isFirstLogin === 'Y') {
                        info.isFirstLogin = true;
                    }
                    info.success = true;
                    observer.next(info);
                    observer.complete();
                    return;
                }, function (error) {
                    console.log('登录error:', error);
                    _this.dwMessage.error(error.error.errorMessage);
                    info.success = false;
                    info.description = error.error.errorMessage;
                    observer.error(info);
                    observer.complete();
                });
            }
            /*this.http.post(this.iamURL + 'identity/login', this.userConfig)
              .subscribe((userData) => {
                console.log('userData>>>>>>>', userData);
                if (!userData) {
                  info.success = false;
                  info.description = '登入失敗';
                  observer.next(info);
                  observer.complete();
                  return;
                }
  
                this.setLogined(userData);
                observer.next(info);
                observer.complete();
                return;
              },
              error => {
                observer.error(error)
                observer.complete();
              }
              );*/
        });
        //});
    };
    return FxAuthService;
}(DwAuthService));
export { FxAuthService };
